import React, { useState, useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Row, Col, Form, Button, Card, ListGroup } from 'react-bootstrap';
import { AuthContext } from '../context/AuthContext';
import ForgotPassword from './ForgotPassword';
import Alert from './common/Alert';
import { fetchProducts } from '../services/products';

const SubscribersPage = () => {
  const [activeTab, setActiveTab] = useState('login');
  const [loginEmail, setLoginEmail] = useState('');
  const [loginPassword, setLoginPassword] = useState('');
  const [registerName, setRegisterName] = useState('');
  const [registerEmail, setRegisterEmail] = useState('');
  const [registerPassword, setRegisterPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [products, setProducts] = useState([]);

  const { login, register } = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    const loadProducts = async () => {
      try {
        const data = await fetchProducts();
        setProducts(data);
      } catch (err) {
        setError('Errore nel caricamento dei prodotti');
      }
    };
    loadProducts();
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    const result = await login(loginEmail, loginPassword);
    if (result.success) {
      setSuccess('Login effettuato con successo!');
      navigate('/dashboard');
    } else {
      setError(result.error);
    }
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    const result = await register(registerName, registerEmail, registerPassword);
    if (result.success) {
      setSuccess('Registrazione completata! Benvenuto!');
      navigate('/dashboard');
    } else {
      setError(result.error);
    }
  };

  return (
    <div className="min-vh-100 bg-light">
      <header className="bg-white shadow-sm">
        <Container className="py-3">
          <div className="d-flex justify-content-between align-items-center">
            <h1 className="fw-bold">API Solutions</h1>
            <div className="d-flex align-items-center">
              <Button variant="link" className="me-2" onClick={() => setActiveTab('login')}>
                Accedi
              </Button>
              <Button variant="primary" onClick={() => setActiveTab('register')}>
                Registrati
              </Button>
            </div>
          </div>
        </Container>
      </header>

      {activeTab === 'forgot' ? (
        <ForgotPassword onBackToLogin={() => setActiveTab('login')} />
      ) : (
        <Container className="mt-4">
          <Row className="justify-content-center">
            <Col md={6} lg={5}>
              <Card className="shadow-sm">
                <Card.Body>
                  <Alert variant="danger" message={error} />
                  <Alert variant="success" message={success} />
                  {activeTab === 'login' ? (
                    <>
                      <div className="d-flex align-items-center justify-content-center mb-4">
                        <span className="fs-4 me-2">🔒</span>
                        <h2 className="fw-bold mb-0">Accedi</h2>
                      </div>
                      <Form onSubmit={handleLogin}>
                        <Form.Group className="mb-3">
                          <Form.Label>Email</Form.Label>
                          <Form.Control
                            type="email"
                            value={loginEmail}
                            onChange={(e) => setLoginEmail(e.target.value)}
                            required
                          />
                        </Form.Group>
                        <Form.Group className="mb-4">
                          <Form.Label>Password</Form.Label>
                          <Form.Control
                            type="password"
                            value={loginPassword}
                            onChange={(e) => setLoginPassword(e.target.value)}
                            required
                          />
                        </Form.Group>
                        <div className="d-grid">
                          <Button variant="primary" type="submit">
                            Accedi
                          </Button>
                        </div>
                        <div className="text-center mt-3">
                          <a href="#" className="text-decoration-none" onClick={() => setActiveTab('forgot')}>
                            Password dimenticata?
                          </a>
                        </div>
                      </Form>
                    </>
                  ) : (
                    <>
                      <div className="d-flex align-items-center justify-content-center mb-4">
                        <span className="fs-4 me-2">👤</span>
                        <h2 className="fw-bold mb-0">Registrati</h2>
                      </div>
                      <Form onSubmit={handleRegister}>
                        <Form.Group className="mb-3">
                          <Form.Label>Nome completo</Form.Label>
                          <Form.Control
                            type="text"
                            value={registerName}
                            onChange={(e) => setRegisterName(e.target.value)}
                            required
                          />
                        </Form.Group>
                        <Form.Group className="mb-3">
                          <Form.Label>Email</Form.Label>
                          <Form.Control
                            type="email"
                            value={registerEmail}
                            onChange={(e) => setRegisterEmail(e.target.value)}
                            required
                          />
                        </Form.Group>
                        <Form.Group className="mb-4">
                          <Form.Label>Password</Form.Label>
                          <Form.Control
                            type="password"
                            value={registerPassword}
                            onChange={(e) => setRegisterPassword(e.target.value)}
                            required
                          />
                        </Form.Group>
                        <div className="d-grid">
                          <Button variant="primary" type="submit">
                            Crea account
                          </Button>
                        </div>
                        <div className="text-center mt-3">
                          <p className="mb-0">
                            Hai già un account?{' '}
                            <a href="#" className="text-decoration-none" onClick={() => setActiveTab('login')}>
                              Accedi
                            </a>
                          </p>
                        </div>
                      </Form>
                    </>
                  )}
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      )}

      <section className="py-5 mt-5 bg-light">
        <Container>
          <div className="text-center mb-5">
            <h2 className="fw-bold display-5">Piani e prezzi</h2>
            <p className="lead text-muted">Scegli il piano che meglio si adatta alle tue esigenze</p>
          </div>
          <Row>
            {products.map((plan) => (
              <Col key={plan._id} md={4} className="mb-4">
                <Card className={`h-100 shadow-sm ${plan.recommended ? 'border-primary' : ''}`}>
                  {plan.recommended && (
                    <div className="bg-primary text-white p-2 text-center">Consigliato</div>
                  )}
                  <Card.Body className="d-flex flex-column">
                    <Card.Title as="h3" className="fw-bold">{plan.title}</Card.Title>
                    <div className="my-3">
                      <span className="display-5 fw-bold">€{plan.price}</span>
                      <span className="text-muted">{plan.frequency}</span>
                    </div>
                    <ListGroup variant="flush" className="mb-4">
                      {plan.features.map((feature, idx) => (
                        <ListGroup.Item key={idx} className="border-0 ps-0">
                          <i className="bi bi-check-circle-fill text-success me-2"></i>
                          {feature}
                        </ListGroup.Item>
                      ))}
                    </ListGroup>
                    <div className="mt-auto">
                      <Button
                        variant={plan.recommended ? 'primary' : 'outline-primary'}
                        className="w-100"
                        onClick={() => navigate('/dashboard')}
                      >
                        {plan.recommended ? 'Inizia ora' : 'Seleziona piano'}
                      </Button>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>
    </div>
  );
};

export default SubscribersPage;